import { render } from "./MiniCart.vue?vue&type=template&id=8988bd44&scoped=true&ts=true"
import script from "./MiniCart.vue?vue&type=script&lang=ts"
export * from "./MiniCart.vue?vue&type=script&lang=ts"

import "./MiniCart.vue?vue&type=style&index=0&id=8988bd44&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8988bd44"]])

export default __exports__